import Select from 'react-select';
import { setSearchType } from '../../redux/dataSlice';
import { useDispatch, useSelector } from 'react-redux';
import '../../assets/styles.css';

export default function DropDownSearchType() {
    const searchType = useSelector(state => state.data.searchType);
    const dispatch = useDispatch();

    const options = [
        { value: 'FormatName', label: 'Name' },
        { value: 'FormatNumber', label: 'Number' },
        { value: 'Date', label: 'Date' },
    ];

    const handleSearchTypeChange = (src) => {
        dispatch(setSearchType(src));
    };

    return (
        <div className='flex items-center gap-4 flex-nowrap'>
            <span className='w-130'>
                <Select options={options}
                    defaultValue={options.find(x => x.value === searchType)}
                    select onChange={(e) => handleSearchTypeChange(e.value)}
                />
            </span>
        </div>
    )
}